__webpack_require__.p = "/border-radius-tokens/account-setup/";